import React from "react";

import lbl from "../../../../data/Labels.json";

import BarChartCard from "./BarChartCard";

const SummaryReport = ({ data }) => {
  return (
    <div className="finance-wrapper-box">
      <h5 className="title">{lbl.Summary}</h5>
      <BarChartCard data={data} />
    </div>
  );
};

export default SummaryReport;
